export default function getInitState() {
    return {
        employabilityNonValidatedDocumentsDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        employabilityNonValidatedDocumentsRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'selectDocument'
            },
        ],
        employabilityNonValidatedDocumentsHeaderFields: [
            {
                name: "treatment.startDate",
                label: "Kezelés időpontja",
                visibility: true,
                slot_name: "startDate_format",
            },
            {
                name: "employabilityType.text",
                label: "Típusa",
                visibility: true,
            },
            {
                name: "capableStatus.text",
                label: "Alkalmasság",
                visibility: true,
                formType: 'select',
            },
            {
                name: "validity",
                label: "Érvényesség",
                visibility: true,
                formType: 'select',
                slot_name: "date_format",
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ]
    }
}
